import './postal-address-modal.scss'
import React, { useEffect, useState } from 'react'
import { Modal } from '@entur/modal'
import { PrimaryButton, SecondaryButton } from '@entur/button'
import { Dropdown } from '@entur/dropdown'
import { space } from '@entur/tokens'
import { Employee, FamilyMember, Fetch, FetchState } from '../../api-clients/api-types'
import { ModalErrorAlert } from '../modal/modal-error-alert'
import { DownloadRequest } from '../../api-clients/client-hooks'

type PostalAddressModalProps = {
  open: boolean
  close: () => void
  employee: Employee
  familyMembersResponse: Fetch<FamilyMember[]>
  download: (downloadRequest: DownloadRequest) => void
  downloadResponse: Fetch<undefined>
}

export const PostalAddressModal: React.FC<PostalAddressModalProps> = (props) => {
  const [isDownloading, setIsDownloading] = useState(true)

  const employee = {
    label: `${props.employee.firstName} ${props.employee.surname} (Rettighetseier)`,
    value: new URLSearchParams({
      employeeNo: props.employee.employeeNo,
      firstName: props.employee.firstName,
      surname: props.employee.surname,
      dateOfBirth: props.employee.dateOfBirth.toString(),
      companyId: props.employee.company.companyId.toString(),
      format: 'addresses-pdf',
    }).toString(),
  }
  const [query, setQuery] = useState(employee.value)

  const familyMembers =
    props.familyMembersResponse.status === FetchState.SUCCESS &&
    props.familyMembersResponse.data.map((familyMember) => ({
      label: `${familyMember.firstName} ${familyMember.surname} (${familyMember.relation.description})`,
      value: new URLSearchParams({
        firstName: familyMember.firstName,
        surname: familyMember.surname,
        dateOfBirth: familyMember.dateOfBirth.toString(),
        format: 'addresses-pdf',
      }).toString(),
    }))
  const recipients = [employee].concat(Array.isArray(familyMembers) ? familyMembers : [])
  const selectedRecipient = recipients.find((item) => item.value === query) ?? employee

  const downloadPostAddress = (queryString: string) => {
    setIsDownloading(true)
    props.download({
      query: `?${queryString}`,
      backupFileName: `postadresser.pdf`,
    })
  }

  useEffect(() => {
    if (isDownloading && props.downloadResponse.status === FetchState.BLOB_SUCCESS) {
      setIsDownloading(false)
      props.close()
    }
  }, [props, isDownloading])

  return (
    <Modal
      className="postal-address-modal"
      size="medium"
      title="Skriv ut postadresse"
      data-cy="postal-address-modal"
      open={props.open}
      onDismiss={props.close}
    >
      {props.familyMembersResponse.status === FetchState.ERROR && (
        <ModalErrorAlert title="Kan ikke hente inn familiemedlemmer" />
      )}
      {props.downloadResponse.status === FetchState.ERROR && (
        <ModalErrorAlert title="Kan ikke lage postadresser" />
      )}
      <Dropdown<string>
        label="Mottaker"
        className="postal-address-modal__dropdown"
        style={{ marginBottom: space.extraLarge5 }}
        selectedItem={selectedRecipient}
        items={recipients}
        onChange={(e) => {
          if (e) {
            setQuery(e.value)
          }
        }}
      />
      <PrimaryButton
        className="postal-address-modal__primary-button"
        data-cy="postal-address-modal-download-button"
        style={{ marginRight: space.medium }}
        loading={props.downloadResponse.status === FetchState.LOADING}
        onClick={() => downloadPostAddress(query)}
      >
        Last ned pdf
      </PrimaryButton>
      <SecondaryButton onClick={props.close}>Avbryt nedlasting</SecondaryButton>
    </Modal>
  )
}
